module.exports = __webpack_public_path__ + "img/jm.5e2a7d00.png";